import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M469.333333 170.666667 554.666667 170.666667 554.666667 682.666667 789.333333 448 849.92 508.586667 512 846.506667 174.08 508.586667 234.666667 448 469.333333 682.666667 469.333333 170.666667Z\" p-id=\"16868\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol